import { useLanguageStore } from 'services/store/language';
import type { Locale } from 'types';

export const useLanguage = (): Locale => useLanguageStore(st => st.language);
